
// import { localstore_allships_scores, localstore_allships_settings } from '/core/constants/localstorage.js';
// import * as localStorage from '/core/lib/localStorage.js';

export function fetchSettings() {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_ALLSHIPS_SETTINGS_PENDING' });

    // await localStorage.clearItem(localstore_allships_settings);
    // const payload = await localStorage.getItem(localstore_allships_settings, {});

    dispatch({ type: 'FETCH_ALLSHIPS_SETTINGS_FULFILLED', payload });
    return payload;
  };
}

export function upsertSettings(settings) {
  return async (dispatch) => {
    dispatch({ type: 'UPSERT_ALLSHIPS_SETTINGS_PENDING' });

    // await localStorage.setItem(localstore_allships_settings, settings);

    dispatch({ type: 'UPSERT_ALLSHIPS_SETTINGS_FULFILLED', payload: settings});
    return true;

  };
}

export function fetchScores() {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_ALLSHIPS_SCORES_PENDING' });

    // const payload = await localStorage.getItem(localstore_allships_scores, []);

    // dispatch({ type: 'FETCH_ALLSHIPS_SCORES_FULFILLED', payload });
    // return payload;
  };
}

export function upsertScore(item) {
  return async (dispatch) => {
    dispatch({ type: 'UPSERT_ALLSHIPS_SCORES_PENDING' });

    // const scores = await localStorage.getItem(localstore_allships_scores, []);
    // const idx = scores.findIndex((score) => score.id === item.id);

    try {
    //   if (idx === -1) {
    //     await localStorage.appendItem(localstore_allships_scores, item);
    //     // console.log("append", item);
    //   } else {
    //     // console.log("update", item)
    //     await localStorage.updateItem(localstore_allships_scores, item.id, item);
    //   }

      dispatch({ type: 'UPSERT_ALLSHIPS_SCORES_FULFILLED', payload: item});
      return true;
    } catch {
      return false;
    }
  };
}

export function clearScores() {
  return async (dispatch) => {
    dispatch({ type: 'CLEAR_ALLSHIPS_SCORES_PENDING' });

    // await localStorage.clearItem(localstore_allships_scores);
    dispatch({ type: 'CLEAR_ALLSHIPS_SCORES_FULFILLED' });
  };
}
